import React, { useState, useEffect } from 'react';
import ten from 'assets/images/ten.svg';
import LazyLoad from 'react-lazyload';
import { EMOJI } from '../../../shared/enums';

const HeroFancyHeading = () => {
  const [ isImgLoading, setIsImgLoading ] = useState(false);
  const [ awaitImgLoad, setAwaitImgLoad ] = useState(false);

  useEffect(() => {
    if (!isImgLoading) return;
    const timer = setTimeout(() => {
      setAwaitImgLoad(true);
    }, 500);

    // eslint-disable-next-line consistent-return
    return () => clearTimeout(timer);
  }, [ isImgLoading ]);

  return (
    <section className='hero hero--fancy-heading'>
      <div className='container'>
        <h1 className='hero__title hero__title--fancy'>
        See How Mila Solves
        <span className='screen-reader-text'>10</span>

          <figure className='primary-title img-relative'>
            {!awaitImgLoad && <div className='image-placeholder' style={{ aspectRatio: `${950 / 360}` }} />}
            <LazyLoad className={`${!awaitImgLoad ? 'img-absolute' : ''}`}>
              <img
                src={ten}
                alt='Ten'
                onLoad={() => setIsImgLoading(true)}
              />
            </LazyLoad>
          </figure>
          <span className='secondary-title'>
          Big Problems Other Air Purifiers Can't Fix
          </span>
        </h1>
        <p className='hero__description'>(Not to mention a bunch of smaller, yet still totally annoying, problems.)</p>
      </div>
    </section>
  );
};
export default HeroFancyHeading;
